import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Paper, useMediaQuery } from '@mui/material';
import Titlebar from '../TitleBar';
import { Pagination, SearchTable, TableBody, TableBottom, TableHeader } from '.';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../Utils/table';
import { adminStkInwMenu, StkInwMenu, UStkInwMenu, Zones } from '../TitleList';
import { fetchUserStkInwData } from '../../Store/PHPSlice/StkInw';
import { selectLocations, selectStudents, selectUstkInwdata } from '../Selectors/Master/OutwardSelectors';
import Dropdown from '../FieldsComponents/Dropdown';
import { fetchStudentData } from '../../Store/PHPSlice/zone';
import { fetchLocationData } from '../../Store/PHPSlice/LocationApi';
import axios from 'axios';


const UstkInwReg = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const dispatch = useDispatch();
    const getItems = useSelector(selectUstkInwdata);
    const allschls = useSelector(selectLocations);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);
    const [activeMenu, setActiveMenu] = useState(StkInwMenu);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');
    const [formData, setFormData] = useState({
        schlId: '',
    });
    const [schlList, setSchlList] = useState([]);

    useEffect(() => {
        if (userdata?.role !== '1') {
            dispatch(fetchUserStkInwData({ userId: userdata?.ID }));
        } else {
            dispatch(fetchUserStkInwData());
            dispatch(fetchLocationData());
        }
    }, [dispatch]);

    useEffect(() => {
        if (!userdata) return;


        if (userdata?.pageIds?.length > 0 && userdata?.role !== '1') {
            const pid = userdata?.pageIds?.find(item => item === 1);
            if (pid === 1 && userdata?.role === '3') {
                setActiveMenu(adminStkInwMenu);
            } else if (userdata?.role === '2') {
                setActiveMenu(UStkInwMenu);
            } else {
                setActiveMenu(StkInwMenu);
            }

            const selectpid = userdata?.pageIds?.filter(item => item === 1 || item === 2);
            if (selectpid?.length > 0) {
                const data = {
                    uid: userdata?.ID,
                    pageId: selectpid
                };
                fetchPageAssignSchools(data);
            }
        }
    }, []);



    const fetchPageAssignSchools = async (id) => {
        const { uid, pageId } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getUserwisePageIdSchools&uid=${uid}&pageId=${pageId}`);
            setSchlList(response?.data?.data);
            // console.log(response.data)

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    if (!getItems) {
        return <h1>Loading...</h1>;
    }

    // console.log(getItems);


    const compData = Array.isArray(getItems.data) ? getItems.data.map((item, index) => (
        {
            srNo: item.ID,
            dt: item.dt,
            billNo: item.billNo,
            stk_type: item.stk_type,
            schlMemo: item.schlMemo,
            schlId: item.schlId,
            schlNm: item.schlNm,
            schlcd: item.schlcd,
            partyId: item.partyId,
            partyNm: item.partyNm,
            firmId: item.firmId,
            firmNm: item.firmNm,
            discnt_val: item.discnt_val,
            totqty: item.totqty,
            totsrate: item.totsrate,
            totdisrate: item.totdisrate,
            totdisamt: item.totdisamt,
            uname: item.uname,
            sts: item.sts,
            serialNumber: index + 1
        }
    )) : [];


    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };



    const totalCount = compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);


    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.schlMemo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.schlNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.partyNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.stk_type?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.totqty), 0);
    const totsrate = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.totsrate), 0);
    const totdisrate = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.totdisrate), 0);
    const totamt = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.totdisamt), 0);

    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),

    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };
    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };


    const dropdownOrdType = [

        {
            label: 'School',
            id: 'schlId',
            options: userdata?.role !== '1' ? schlList : allschls?.data || [],
            value: formData.schlId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlId', value: newValue ? newValue.ID : '' } }, 'schlId'),
            getOptionLabel: (option) => option.schlcd || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true,

        }

    ];

    const handleSearch = (e) => {
        e.preventDefault();

        // if (formData.fdt === '') {
        //     alert('Please Select From Date.');
        //     return; // Stop form submission
        // }
        // if (formData.tdt === '') {
        //     alert('Please Select To Date.');
        //     return; // Stop form submission
        // }

        dispatch(fetchUserStkInwData({ schlId: formData.schlId }));
    };

    return (
        <>
            {/* <Titlebar data={userdata?.role === '2' ? UStkInwMenu : StkInwMenu} /> */}
            <Titlebar data={activeMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2> School Stock Inward Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <Grid container spacing={0.5}>
                                {
                                    dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSearch}>Search</Button>

                                </Grid>
                            </Grid>
                            <Grid item xs={12} textAlign="center" style={{ marginTop: '4%' }}>
                            </Grid>
                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }}>
                                <Table>
                                    <TableHeader
                                        headCells={[
                                            { id: 'srNo', label: 'Sr.No' },
                                            { id: 'dt', label: 'Date' },
                                            { id: 'stk_type', label: 'Inward Type' },
                                            { id: 'billNo', label: 'Bill No' },
                                            { id: 'schlMemo', label: 'Stk Memo' },
                                            { id: 'firmNm', label: 'Firm' },
                                            { id: 'schlcd', label: 'School' },
                                            // { id: 'partyNm', label: 'Party' },
                                            // { id: 'discnt_val', label: 'Discount(%)' },
                                            { id: 'totqty', label: 'Total Qty.' },
                                            { id: 'totsrate', label: 'Total Sale Rate' },
                                            { id: 'totdisrate', label: 'Total Discount Rate' },
                                            { id: 'totdisamt', label: 'Total Amount' },
                                            { id: 'view', label: 'View' },
                                            { id: 'uname', label: 'Accepted' },
                                            // { id: 'edit', label: 'Edit' },
                                            // { id: 'delete', label: 'Delete' }
                                        ]}

                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />

                                    <tbody>
                                        {displayedData && displayedData.length > 0 ? (
                                            <>
                                                {displayedData?.map((row) => (
                                                    <TableBody
                                                        key={row.srNo}
                                                        id={row.srNo}
                                                        dt={row.dt}
                                                        billNo={row.billNo}
                                                        stk_type={row.stk_type}
                                                        schlMemo={row.schlMemo}
                                                        schlcd={row.schlcd}
                                                        schlNm={row.schlNm}
                                                        partyId={row.partyId}
                                                        partyNm={row.partyNm}
                                                        firmId={row.firmId}
                                                        firmNm={row.firmNm}
                                                        discnt_val={row.discnt_val}
                                                        totqty={row.totqty}
                                                        totsrate={row.totsrate}
                                                        totdisrate={row.totdisrate}
                                                        totdisamt={row.totdisamt}
                                                        sts={row.sts}
                                                        uname={row.uname}
                                                        serialNumber={row.serialNumber}
                                                        selected={selected.indexOf(row.name) !== -1}
                                                        handleClick={(event) => handleClick(event, row.name)}
                                                    />
                                                ))}

                                                <TableBottom
                                                    totamt={totamt}
                                                    totdisrate={totdisrate}
                                                    totqty={totqty}
                                                    totsrate={totsrate}
                                                />
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan={12} style={{ textAlign: "center", padding: "10px" }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default UstkInwReg;
